import(/* webpackMode: "eager" */ "/opt/atlassian/pipelines/agent/build/application/src/app/[product]/forecast/today/template.tsx");
